'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _reactackleIcons = require('reactackle-icons');

var _styles = require('./styles');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MenuItemType = _propTypes2.default.shape({
  type: _propTypes2.default.func,
  submenuGroup: _propTypes2.default.shape({
    type: _propTypes2.default.func,
    // Lazy function for circular structure
    data: _propTypes2.default.arrayOf(function () {
      return function () {
        return MenuItemType;
      }();
    })
  })
});

var propTypes = {
  /**
   * Define component's color scheme
   */
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),

  /**
   * Item index
   */
  index: _propTypes2.default.number,

  /**
   * Adds home icon
   */
  home: _propTypes2.default.bool,

  /**
   * Item's title
   */
  title: _propTypes2.default.string,

  /**
   * Item's subtitle
   */
  subtitle: _propTypes2.default.string,

  /**
   * Define separator
   */
  separatorIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * Item's href
   */
  itemHref: _propTypes2.default.string,

  /**
   * Active item isn't clickable and have special appearance
   */
  isActive: _propTypes2.default.bool,

  /**
   * Component to be used as a link
   */
  linkComponent: _propTypes2.default.func,

  /**
   * Content's vertical align
   */
  alignItems: _propTypes2.default.oneOf(['top', 'center', 'bottom']),
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    linkHref: _propTypes2.default.string,
    type: _propTypes2.default.func,
    data: _propTypes2.default.arrayOf(MenuItemType)
  })),

  /**
   * ariaCurrentValue value
   */
  ariaCurrentValue: _propTypes2.default.string,
  saveRef: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  // eslint-disable-next-line react/require-default-props
  theme: _propTypes2.default.object
};
var defaultProps = {
  colorScheme: 'dark',
  index: 0,
  home: false,
  title: '',
  subtitle: '',
  separatorIcon: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, {
    size: 'custom',
    color: 'currentColor'
  }),
  itemHref: '#',
  isActive: false,
  linkComponent: null,
  alignItems: 'center',
  saveRef: _reactackleCore.noop,
  onClick: _reactackleCore.noop,
  options: [],
  ariaCurrentValue: 'item'
};

var BreadcrumbsItem = function (_Component) {
  _inherits(BreadcrumbsItem, _Component);

  function BreadcrumbsItem(props) {
    _classCallCheck(this, BreadcrumbsItem);

    var _this = _possibleConstructorReturn(this, (BreadcrumbsItem.__proto__ || Object.getPrototypeOf(BreadcrumbsItem)).call(this, props));

    _this.state = {
      left: 0,
      top: 0,
      isPortalOpened: false
    };
    _this._wrapper = null;
    _this._createElementRef = _this._createElementRef.bind(_this);
    _this._handleClick = _this._handleClick.bind(_this);
    return _this;
  }

  _createClass(BreadcrumbsItem, [{
    key: '_handleClick',
    value: function _handleClick(event) {
      if (this.props.onClick !== _reactackleCore.noop) this.props.onClick({
        index: this.props.index
      }, event);
    }
  }, {
    key: '_createElementRef',
    value: function _createElementRef(ref) {
      this._wrapper = ref;
      this.props.saveRef(this.props.index, ref);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          colorScheme = _props.colorScheme,
          isActive = _props.isActive,
          alignItems = _props.alignItems,
          theme = _props.theme,
          ariaCurrentValue = _props.ariaCurrentValue,
          separatorIcon = _props.separatorIcon;
      var componentThemePath = theme.reactackle.components.breadcrumbs.item;

      var breadcrumbsIcon = this.props.home && _react2.default.createElement(_styles.IconHomeStyled, {
        colorScheme: colorScheme
      }, componentThemePath.iconHome.source);

      var itemHref = this.props.itemHref && !this.props.isActive ? this.props.itemHref : null;

      var subtitle = this.props.subtitle && _react2.default.createElement(_styles.SubtitleStyled, {
        colorScheme: colorScheme
      }, this.props.subtitle);

      var arrow = this.props.options && this.props.options.length ? _react2.default.createElement(_styles.IconBoxStyled, {
        colorScheme: colorScheme
      }, componentThemePath.iconMenuSource) : null;
      var AnchorElement = this.props.linkComponent ? _styles.AnchorStyled.withComponent(this.props.linkComponent) : _styles.AnchorStyled;
      var ariaProps = {};
      if (ariaCurrentValue && isActive) ariaProps = {
        'aria-current': ariaCurrentValue
      };

      var separator = _react2.default.createElement(_styles.SeparatorStyled, {
        colorScheme: colorScheme
      }, separatorIcon);

      return _react2.default.createElement(_styles.BreadcrumbsItemStyled, {
        innerRef: this._createElementRef,
        colorScheme: colorScheme
      }, _react2.default.createElement(AnchorElement, _extends({
        href: itemHref,
        alignItems: alignItems,
        onClick: this._handleClick,
        colorScheme: colorScheme,
        active: isActive
      }, ariaProps), breadcrumbsIcon, _react2.default.createElement(_styles.TextBoxStyled, null, _react2.default.createElement(_styles.TitleStyled, {
        colorScheme: colorScheme,
        active: isActive
      }, this.props.title), subtitle), arrow), separator);
    }
  }]);

  return BreadcrumbsItem;
}(_react.Component);

BreadcrumbsItem.propTypes = propTypes;
BreadcrumbsItem.defaultProps = defaultProps;
BreadcrumbsItem.displayName = 'BreadcrumbsItem';
exports.default = (0, _reactackleCore.withTheme)(BreadcrumbsItem);